
import axios from '../config/axios';

export const url = '/api/posiblesempleadosb2x2x'


export const createposiblesempleadosb2x2x = ({
  token,
	nombreh1j7x,
	apellidobiaili,
	correo264zh,
	telefonoelc6q,
	vacanteo3iil,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombreh1j7x && apellidobiaili && correo264zh && telefonoelc6q && vacanteo3iil ) {

    axios.post(`${url}//create/basic/69cd77cdb08e22defc4d8ad9`, {
		nombreh1j7x,
		apellidobiaili,
		correo264zh,
		telefonoelc6q,
		vacanteo3iil,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombreh1j7x) {
		reject({
			status: 'error',
			info: 'Nombre no esta definido',
		});
	}  else if (!apellidobiaili) {
		reject({
			status: 'error',
			info: 'Apellido no esta definido',
		});
	}  else if (!correo264zh) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else if (!telefonoelc6q) {
		reject({
			status: 'error',
			info: 'Telefono no esta definido',
		});
	}  else if (!vacanteo3iil) {
		reject({
			status: 'error',
			info: 'Vacante no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

